import { useContextMenu } from "../../../../../../../../hooks/useContextMenu";
import useUserConfig from "../../../../../../../../hooks/useUserConfig";
import { SourceFilesListProps } from "./SourceFilesList";

/** Handle logic for a custom context menu to act on selected list elements. */
export default function useHandleContextMenu(
    props: SourceFilesListProps,
    handleClick: (e: React.MouseEvent, i: number) => void,
) {
    const { userConfig } = useUserConfig();
    const isMenuEnabled = userConfig.showCustomContextMenus;

    const { isShowingMenu, showMenu, hideMenu, menuCoords } = useContextMenu();

    function handleContextMenu(event: React.MouseEvent, index: number) {
        event.preventDefault();
        if (!isMenuEnabled) {
            return;
        }

        // Add right-clicked item to the selected items list so that context menu actions will apply to it too
        if (!props.selectedFiles.includes(index)) {
            handleClick(event, index);
        }
        showMenu({ x: event.pageX, y: event.pageY });
    }

    function removeSelectedFiles() {
        const nextFiles = props.sourceFiles.filter((_, i) => !props.selectedFiles.includes(i));

        if (nextFiles.length) {
            props.setSourceFiles(nextFiles);
        } else {
            props.resetSourceFiles();
        }
        hideMenu();
        props.resetSelectedFiles();
    }

    return { isShowingMenu, hideMenu, menuCoords, removeSelectedFiles, handleContextMenu };
}
